"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEGABYTE = exports.FILE_CATEGORY_RULES = void 0;
var MEGABYTE = 1024 * 1024;
exports.MEGABYTE = MEGABYTE;
// Mirrors the API registry for early rejection; the API remains the authority.
var FILE_CATEGORY_RULES = {
    profile_photo: {
        label: "Profile photo",
        acceptedTypes: ["image/jpeg", "image/png", "image/webp"],
        maxSize: 5 * MEGABYTE,
        resize: { size: 512, quality: 0.85, contentType: "image/jpeg", extension: "jpg" },
    },
    phyto_certificate: { label: "Phytosanitary certificate", acceptedTypes: ["application/pdf", "image/jpeg", "image/png"], maxSize: 100 * MEGABYTE },
    certificate_of_analysis: { label: "Certificate of analysis", acceptedTypes: ["application/pdf", "image/jpeg", "image/png"], maxSize: 100 * MEGABYTE },
    document: {
        label: "Document",
        acceptedTypes: [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ],
        maxSize: 100 * MEGABYTE,
    },
};
exports.FILE_CATEGORY_RULES = FILE_CATEGORY_RULES;
